"use strict";

exports.__esModule = true;
exports.timestamp = void 0;
var _domain = require("../domain");
const timestamp = exports.timestamp = {
  types: ['google.protobuf.Timestamp'],
  [_domain.ConverterType.TO_JSON]: {
    transform: val => val == null ? void 0 : val.toISOString()
  },
  [_domain.ConverterType.FROM_JSON]: {
    transform: val => val ? new Date(val) : undefined
  }
};
//# sourceMappingURL=timestamp.js.map